import { render, staticRenderFns } from "./saidas_filial_por_classe.vue?vue&type=template&id=ba9ba43c&"
import script from "./saidas_filial_por_classe.vue?vue&type=script&lang=js&"
export * from "./saidas_filial_por_classe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports